import * as React from 'react'
import dynamic from 'next/dynamic'

import { spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { Button } from '@thg-commerce/gravity-elements'
import SvgIcon from '@thg-commerce/gravity-icons/src/components/SvgIcon'
import { TextStyling } from '@thg-commerce/gravity-patterns'
import { css } from '@thg-commerce/gravity-theme'

const SvgSizeGuide = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/SizeGuide'),
)

const StyledButton = styled(Button)`
  svg {
    fill: ${(props) => props.theme.colors.palette.greys.darker};
    margin-right: ${spacing(1)};
  }
  &:hover svg {
    fill: ${(props) => props.theme.colors.palette.brand.base};
  }
  &:focus-visible {
    border-color: ${(props) => props.theme.colors.palette.greys.darker};
  }
`

const StyledButtonText = styled.div<{ textStyling?: TextStyling }>`
  ${(props) =>
    props.textStyling &&
    css`
      ${Text(props.textStyling.entry, props.textStyling.style)};
      text-transform: ${props.textStyling.transform};
      text-decoration: ${props.textStyling.textDecoration};
    `}
`
export interface SizeGuideTriggerProps {
  onClick: (e?: React.SyntheticEvent) => void
  i18nText: {
    triggerText: String
  }
  textStyling?: TextStyling
  svg?: {
    svgPath: string
    width: string
    height: string
    viewBox: string
  }
}

export const SizeGuideTrigger = (props: SizeGuideTriggerProps) => {
  return (
    <StyledButton
      sizing="regular"
      emphasis="low"
      onClick={(e) => {
        props.onClick(e)
      }}
      data-testid="size-guide-trigger"
    >
      {props.svg ? (
        <SvgIcon
          xmlns="http://www.w3.org/2000/svg"
          height={props.svg.height}
          width={props.svg.width}
          viewBox={props.svg.viewBox}
        >
          <path d={props.svg.svgPath} />
        </SvgIcon>
      ) : (
        <SvgSizeGuide />
      )}
      <StyledButtonText textStyling={props.textStyling}>
        {props.i18nText.triggerText}
      </StyledButtonText>
    </StyledButton>
  )
}
